import { Box, Button, Card, CircularProgress, Stack, Typography } from '@mui/material';
import useAuth from 'hooks/useAuth';
import DashboardLayout from 'layouts/Dashboard/DashboardLayout';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const MyQR = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    const myQR = user?.qrCode;

    const qrSrc = useMemo(() => {
        if (!myQR) return null;
        const encoded = encodeURIComponent(myQR);
        return `https://api.qrserver.com/v1/create-qr-code/?data=${encoded}&size=240x240`;
    }, [myQR]);

    const [isQrLoading, setIsQrLoading] = useState(Boolean(qrSrc));

    useEffect(() => {
        setIsQrLoading(Boolean(qrSrc));
    }, [qrSrc]);
    
    return (
        <DashboardLayout>
            <Box pt={2} pb={4}>
                <Typography variant="h3" component="h1" paragraph>
                    My QR
                </Typography>
                <Card
                    sx={{
                        padding: '2rem 1rem',
                        textAlign: 'center',
                    }}
                >
                    {qrSrc ? (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                minHeight: 260,
                            }}
                        >
                            <Box sx={{ position: 'relative', width: 240, height: 240 }}>
                                {isQrLoading && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            inset: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: 'rgba(255,255,255,0.6)',
                                            borderRadius: 1,
                                        }}
                                    >
                                        <CircularProgress />
                                    </Box>
                                )}

                                <Box
                                    component="img"
                                    alt="My QR Code"
                                    src={qrSrc}
                                    onLoad={() => setIsQrLoading(false)}
                                    onError={() => setIsQrLoading(false)}
                                    sx={{
                                        width: 240,
                                        height: 240,
                                        opacity: isQrLoading ? 0 : 1,
                                        transition: 'opacity 200ms ease',
                                        borderRadius: 1,
                                    }}
                                />
                            </Box>
                        </Box>
                    ) : (
                        <Stack spacing={2} alignItems="center">
                            <Typography>
                                Ups... Please buy any package to get your QR Code.
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/dashboard/choose-package')}
                            >
                                Choose Package
                            </Button>
                        </Stack>
                    )}
                </Card>
            </Box>
        </DashboardLayout>
    );
};

export default MyQR;
